const refreshSoft = () => {
  window.location.reload();
};

const refreshHard = () => {
  window.location.reload(true);
};

export { refreshSoft, refreshHard };
